/** The brain steps whose prompt and model are versioned settings (spec 7.3, 7.4). */
export const PROMPT_CODES = [
  'transcribe',
  'ideas',
  'text_reel',
  'text_carousel',
  'text_diagram',
  'text_listicle',
  'edit',
  'factcheck',
  'profile',
] as const;
export type PromptCode = (typeof PROMPT_CODES)[number];

export const REASONING_EFFORTS = ['low', 'medium', 'high'] as const;
export type ReasoningEffortSetting = (typeof REASONING_EFFORTS)[number];

/**
 * Placeholders a prompt may carry, filled from the passport copy at call time:
 * limits are never written into a prompt as numbers (decision 25).
 */
export const PROMPT_VARS = [
  'hook_max_chars',
  'body_max_chars',
  'cta_max_chars',
  'min_blocks',
  'max_blocks',
  'max_duration_s',
  'words_per_second',
  'max_words',
  'min_slides',
  'max_slides',
  'title_max_chars',
  'text_max_chars',
] as const;
export type PromptVar = (typeof PROMPT_VARS)[number];
